import React from "react";
import { Link } from "react-router-dom";
import { stats } from "../mock";
import { Button } from "../components/ui/button";
import { Award, Heart, Globe, Users, ArrowRight } from "lucide-react";

export default function About() {
  const values = [
    { Icon: Heart, title: "Passion for Travel", desc: "Every journey we craft is rooted in a genuine love for exploration and human connection." },
    { Icon: Award, title: "Award-Winning Service", desc: "18 years of consistently delivering excellence, earning the trust of 2M+ travellers." },
    { Icon: Globe, title: "Global Reach", desc: "From tropical beaches to alpine peaks — we operate seamlessly across 100+ destinations." },
    { Icon: Users, title: "People First", desc: "Our experts take the time to understand you — no cookie-cutter itineraries here." },
  ];

  return (
    <main className="pt-32">
      <section className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-xs tracking-[0.3em] text-[#5c8606] font-semibold">ABOUT US</div>
        <h1 className="font-display text-5xl md:text-6xl font-bold text-slate-800 mt-3 max-w-3xl leading-tight">
          We help you cross winds &amp; borders with confidence.
        </h1>
        <p className="mt-6 text-lg text-slate-600 max-w-3xl">
          Kites Fly - The Travel Companion started with a simple idea — travel should never feel like paperwork.
          Today, we're a full-service travel partner trusted by families, professionals, and adventurers alike.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 mt-16">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <img
            src="https://images.unsplash.com/photo-1502602898657-3e91760cbb34?crop=entropy&cs=srgb&fm=jpg&q=85"
            alt="Paris"
            className="rounded-3xl h-[420px] w-full object-cover"
          />
          <div>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-slate-800">Our Story</h2>
            <p className="mt-4 text-slate-600 leading-relaxed">
              What began as a small travel desk in Palayam, Kozhikode has grown into a trusted name across Kerala — all committed to one thing: delightful travel.
            </p>
            <p className="mt-3 text-slate-600 leading-relaxed">
              We handle visas, flights, hotels, itineraries and every detail in between. Because when you're chasing sunsets, the last thing you should worry about is documentation.
            </p>
            <Link to="/contact">
              <Button className="mt-6 bg-gradient-to-r from-[#84c009] to-[#4f7700] hover:from-[#70a308] hover:to-[#416200] text-white rounded-full px-6 h-11 font-semibold">
                Talk to our team <ArrowRight className="ml-2 w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 mt-24">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((s) => (
            <div key={s.label} className="bg-[#f9fcf3]/60 rounded-2xl p-6 border border-[#f0f7e1] text-center lift">
              <div className="text-4xl font-bold text-[#5c8606]">{s.value}</div>
              <div className="text-sm text-slate-600 mt-2">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 mt-24">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-xs tracking-[0.3em] text-[#5c8606] font-semibold">OUR VALUES</div>
          <h2 className="font-display text-4xl font-bold text-slate-800 mt-2">What we stand for</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mt-10">
          {values.map((v) => (
            <div key={v.title} className="lift bg-white p-6 rounded-2xl border border-slate-100 hover:border-[#ddedba]">
              <div className="w-12 h-12 rounded-xl bg-[#f9fcf3] text-[#70a308] flex items-center justify-center mb-4">
                <v.Icon className="w-6 h-6" />
              </div>
              <h4 className="font-bold text-slate-800">{v.title}</h4>
              <p className="text-sm text-slate-500 mt-2 leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
